import $ from 'jquery';
import slick from 'slick-carousel';
import responsive from './responsive';

const slider = {
  slideHpHeader: (elementHtmlTag) => {
    $(elementHtmlTag).find('.slider--items').slick({
      accessibility: true, // enable tab navigation WAI
      arrows: true,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: false,
      nextArrow: $(elementHtmlTag).find('.slider--next'),
      prevArrow: $(elementHtmlTag).find('.slider--prev'),
      slidesToShow: 1,
      zIndex: 0,
    });
  },
  slideHpNews: (elementHtmlTag) => {
    $(elementHtmlTag).find('.slider--items').slick({
      accessibility: true, // enable tab navigation WAI
      arrows: true,
      centerMode: true,
      nextArrow: $(elementHtmlTag).find('.slider--next'),
      prevArrow: $(elementHtmlTag).find('.slider--prev'),
      slidesToShow: 5,
      zIndex: 0,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: responsive.screens.lg.maxWidth,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: responsive.screens.md.maxWidth,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: responsive.screens.sm.maxWidth,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: responsive.screens.xs.maxWidth,
          settings: {
            slidesToShow: 1,
          }
        }],
    });
  },
  slideHpTrust: (elementHtmlTag) => {
    $(elementHtmlTag).find('.slider--items').slick({
      accessibility: true, // enable tab navigation WAI
      arrows: true,
      centerMode: true,
      nextArrow: $(elementHtmlTag).find('.slider--next'),
      prevArrow: $(elementHtmlTag).find('.slider--prev'),
      slidesToShow: 1,
      variableWidth: true,
      zIndex: 0,
    });
  },
  slideDiscoverParagraph: (elementHtmlTag) => {
    $(elementHtmlTag).find('.slider--items').slick({
      accessibility: true, // enable tab navigation WAI
      arrows: true,
      infinite: false,
      nextArrow: $(elementHtmlTag).find('.slider--next'),
      prevArrow: $(elementHtmlTag).find('.slider--prev'),
      slidesToShow: 4,
      zIndex: 0,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: responsive.screens.lg.maxWidth,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: responsive.screens.md.maxWidth,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: responsive.screens.sm.maxWidth,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: responsive.screens.xs.maxWidth,
          settings: {
            slidesToShow: 1,
          }
        }],
    });
  },
  slideCenterFooter: (elementHtmlTag) => {
    $(elementHtmlTag).find('.slider--items').slick({
      accessibility: true, // enable tab navigation WAI
      arrows: true,
      draggable: false,
      fade: true,
      nextArrow: $(elementHtmlTag).find('.slider--next'),
      prevArrow: $(elementHtmlTag).find('.slider--prev'),
      slidesToShow: 1,
      zIndex: 0,
    });

    slider.addEventToSlide('.footer--map__wrapper .btn-selector', $(elementHtmlTag));


    $(elementHtmlTag).on('afterChange', (event, slick, currentSlide) => {
      $('.footer--map__wrapper .btn-selector[data-slide]').removeClass('current');
      $('.footer--map__wrapper .btn-selector[data-slide=' + currentSlide +']').addClass('current');
    });
  },
  addEventToSlide : (btnCssSelector, sliderHtmltag) => {
    $(btnCssSelector + '[data-slide]').click((e) => {
      e.preventDefault();
      let slideNo = $(e.currentTarget).data('slide');

      if (slideNo || slideNo === '0' || slideNo === 0) {
        sliderHtmltag.find('.slider--items').slick('slickGoTo', slideNo);
      }

      $(btnCssSelector + '[data-slide]').removeClass('current');
      $(e.currentTarget).addClass('current');
    });
  }
};

export default slider;
